import CambiarDelegacionForm from "../Forms/CambiarDelegacionForm";
import CambiarDNIPacienteForm from "../Forms/CambiarDNIPacienteForm";
import CambiarNombrePacienteForm from "../Forms/CambiarNombrePacienteForm";
import CambiarFechaNacimientoForm from "../Forms/CambiarFechaNacimientoForm";
import FormSection from "../Sections/FormSection";
import DesvincularPacienteSAPForm from "../Forms/DesvincularPacienteSAPForm";

export default function TabPaciente() {

    return (
        <>
            <FormSection
                title="Cambiar Delegación"
                description="Puede cambiar solo la delegación del paciente o de un paciente y un contrato. Si ingresa un contrato, debe pertenecer al paciente ingresado."
            >
                <CambiarDelegacionForm />
            </FormSection>

            <FormSection
                title="Cambiar nombre"
            >
                <CambiarNombrePacienteForm />
            </FormSection>

            <FormSection
                title="Cambiar DNI"
            >
                <CambiarDNIPacienteForm />
            </FormSection>
            <FormSection
                title="Cambiar fecha de nacimiento"
            >
                <CambiarFechaNacimientoForm />
            </FormSection>
            <FormSection
                title="Desvincular Código SAP"
            >
                <DesvincularPacienteSAPForm />
            </FormSection>
        </>
    );
}